import { useQuery } from "@tanstack/react-query";
import { Building2 } from "lucide-react";
import { apiRequest } from "@/lib/queryClient";
import type { Organization } from "@/types/organizations";
import type { PaletteSource } from "@/components/layout/palette/paletteSources";

/**
 * Organisations from `GET /organizations` (the list the Organizations page already
 * shows both roles). Same query key as `useOrganizations`, so the cache is shared;
 * nothing is fetched until the palette opens.
 */
export const organizationsSource: PaletteSource = {
  id: "organizations",
  heading: "Organizations",
  minQueryLength: 1,
  useItems(_query, open) {
    const { data, isLoading } = useQuery<Organization[]>({
      queryKey: ["/organizations"],
      queryFn: async () => {
        const response = await apiRequest<Organization[] | { data?: Organization[] }>("GET", "/organizations");
        return Array.isArray(response) ? response : (response?.data ?? []);
      },
      enabled: open,
    });
    const items = (Array.isArray(data) ? data : []).map((org) => ({
      id: org.id,
      label: org.name,
      hint: "Organization",
      icon: Building2,
      href: `/organizations/${org.id}`,
    }));
    return { items, isLoading: open && isLoading };
  },
};
